"use client";

import { ThemeProvider, useTheme } from "next-themes";
import { useEffect } from "react";
import { ToastProvider } from "@/providers/ToastProvider";
import { AuthProvider } from "@/lib/firebase/providers/AuthProvider";
import { ModalProvider } from "@/app/(workspace)/_providers/ModalProvider";
import { usePageTracking } from "@/lib/firebase/hooks/useAnalytics";

function ThemeWatcher() {
  const { resolvedTheme, setTheme } = useTheme();

  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");

    function onMediaChange() {
      const systemTheme = media.matches ? "dark" : "light";
      if (resolvedTheme === systemTheme) {
        setTheme("system");
      }
    }

    onMediaChange();
    media.addEventListener("change", onMediaChange);

    return () => {
      media.removeEventListener("change", onMediaChange);
    };
  }, [resolvedTheme, setTheme]);

  return null;
}

// 페이지 뷰 자동 추적 컴포넌트
function AnalyticsTracker() {
  usePageTracking();
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" disableTransitionOnChange>
      <ThemeWatcher />
      <AnalyticsTracker />
      <AuthProvider>
        <ToastProvider>
          <ModalProvider>{children}</ModalProvider>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
